import { api } from '.';
import { Setting } from '../types';

export const list = () =>
  api.get('/config_table').then((response : any) => response.data.data)

export const update = (setting:Setting) =>
  api.put(`/config_table`, setting).then(response => response.data);
